let _singleton = Symbol();

class PageRendererRegistry {
  constructor(singletonToken) {
    if (_singleton !== singletonToken)
      throw new Error('Cannot instantiate directly.');

    this.pageRenderers = {};
  }

  static get instance() {
    if (!this[_singleton])
      this[_singleton] = new PageRendererRegistry(_singleton);

    return this[_singleton];
  }

  registerPageRenderer(pageId, pageRenderer) {
    this.pageRenderers[pageId] = pageRenderer;
  }

  unRegisterPageRenderer(pageId) {
    delete this.pageRenderers[pageId];
  }

  getPageRenderer(pageId) {
    return this.pageRenderers[pageId];
  }
}

export default PageRendererRegistry;
